'use strict'

// Vendor
import 'bootstrap'

// Project
import sitenavbar from '../components/sitenavbar/sitenavbar.js'
import photoSlider from './photoslider.js'
import articleSlider from './articleslider.js'
import ieFallbacks from './iefallbacks.js'
import stickyFallback from './sticky-masthead-fallback.js'
import breadcrumbPositioning from './breadcrumbpositioning.js'
import formValidationStart from './formvalidationstart.js'

$(document).ready(function () {
  formValidationStart()
  articleSlider()
  photoSlider()
  sitenavbar()
  ieFallbacks()
  stickyFallback('.js-fallback-sticky-elem')
  breadcrumbPositioning()
})
